export class Templates {
  constructor() {}

  public static getTemplates(country) {
    if (!country) {
      country = 'INT';
    }
    const countries = ['AT', 'BE', 'DE', 'FI', 'FR', 'GB', 'INT', 'SE', 'AX'];
    const tCountry = countries.includes(country) ? country : 'INT';
    let templates = [];
    //Besides FI, SE, AX, other countries have only default
    switch (tCountry) {
      case 'FI':
        templates = ['defaultOneP', 'bankFormOneP', 'bankFormBreakdownOneP'];
        break;
      case 'AX':
        templates = ['defaultOneP', 'bankFormOneP', 'bankFormBreakdownOneP'];
        break;
      case 'SE':
        templates = ['defaultOneP', 'bankgiroOneP', 'plusgiroOneP'];
        break;
      default:
        templates = ['default'];
        break;
    }
    return templates.map(t => `${country}.${t}`);
  }
}
